module.exports = function getResource(label, vars = []) {
    const resources = {
        estimatedTotalXItems: `Estimated Total (${vars[0]} items)`,
        estimatedTotal: 'Estimated Total',
        shippingAndTaxes: 'Shipping and taxes calculated during checkout.',
        bopisTaxes: 'Taxes calculated during checkout.',
        youSave: 'You save',
        sduSavingsUS: '$6.95',
        sduSavingsCA: '$9.95',
        withSDUUnlimited: 'with Same-Day Unlimited',
        paymentLegal: 'Some payment methods may not be available for certain items or fulfillment methods.',
        supportedPayment: 'Supported Payment Methods'
    };

    return resources[label];
};
